import "./OrganizationDropdown.scss";

import { map } from "lodash";
import React, { memo, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import { useOrganizationContext } from "../../../contexts/organizations/organizationsContext";
import { CheckIcon, GearIcon, TriangleArrowIcon, UsersIcon } from "../../icons";
import { ProfilePicture } from "../../ProfilePicture/ProfilePicture";

const OrganizationDropdown: React.FC = memo(() => {
  const [show, setShow] = useState(false);

  const { pathname } = useLocation();
  useEffect(() => {
    setShow(false);
  }, [pathname]);

  const { organizations, currentOrganization, setCurrentOrganization } =
    useOrganizationContext();

  const setDropdown = () => {
    setShow(!show);
  };

  return (
    <Dropdown
      show={show}
      className="organization-dropdown"
      onToggle={setDropdown}
    >
      <Dropdown.Toggle
        id="dropdown-autoclose-true"
        as="div"
        className="organization-dropdown__toggle no-arrow"
      >
        <span className="d-flex align-items-center">
          <ProfilePicture label={currentOrganization?.name} />
          <span className="label">{currentOrganization?.name}</span>
        </span>
        <span className="d-flex align-items-center arrow">
          <TriangleArrowIcon />
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="organization-dropdown__list"
        renderOnMount={false}
      >
        <Dropdown.Header className="organization-dropdown__header">
          Your organizations
        </Dropdown.Header>
        {map(organizations, org => {
          return (
            <Dropdown.Item
              as="span"
              className={`organization-dropdown__item organization-dropdown__item--org-item ${
                currentOrganization?.id === org.id ? "active" : ""
              }`}
              key={org.id}
              onClick={() => {
                setCurrentOrganization(org);
              }}
            >
              <span className="d-flex align-items-center">
                <ProfilePicture label={org.name} />
                <span className="label">{org.name}</span>
              </span>
              {currentOrganization?.id === org.id && <CheckIcon />}
            </Dropdown.Item>
          );
        })}
        <Dropdown.Divider className="organization-dropdown__divider" />
        <Link to="/organization/settings" className="dropdown-item">
          <span className="label">
            <GearIcon />
            Settings
          </span>
        </Link>
        <Link to="/organization/members" className="dropdown-item">
          <span className="label">
            <UsersIcon />
            Invite members
          </span>
        </Link>
      </Dropdown.Menu>
    </Dropdown>
  );
});

export { OrganizationDropdown };
